import React from "react";

export default function HistorialBanner() {
  return (
    <div className="ee-historial-banner">
      <div className="ee-historial-banner-icon">📊</div>
      <div className="ee-historial-banner-content">
        <div className="ee-historial-banner-title">
          Ganamos 7 de cada 10 picks. Pero también perdemos.
        </div>
        <div className="ee-historial-banner-text">
          En promedio, el bot acierta el <strong>70%</strong> de los picks. Aún así, <strong>6 a 8 días al mes</strong> vas a ver rachas de <strong>5 o 6 perdidas seguidas</strong> — eso equivale al <span className="ee-historial-banner-o">30%</span> del mes y es matemáticamente normal. La ventaja real se manifiesta en el acumulado del mes, no en una tarde.
        </div>
        <div className="ee-historial-banner-disclaimer">
          Basado en el promedio histórico del motor V6. Resultados pasados no garantizan resultados futuros.
        </div>
      </div>
    </div>
  );
}
